export default function updateProficiency(userProficiency, activityProficiency, actualOutcome, k = 50) {
	const expectedOutcome = 1 / (1 + 10 ** ((activityProficiency - userProficiency) / 400));
	const updatedUserProficiency = userProficiency + k * (actualOutcome - expectedOutcome);

	return updatedUserProficiency;
}
